import { reactLocalStorage } from "reactjs-localstorage";

import Const from "../util/Constants";
import Util from "../util/Util";
import Filter from "../components/filter/FilterPannel";

class FieldController {
  static Equals = "equals";
  static NotEquals = "not-equals";
  static In = "in";
  static NotIn = "not-in";
  static Empty = "empty";
  static NotEmpty = "not-empty";
  static StartWith = "start-with";
  static EndsWith = "end-with";
  static GreaterThan = "greater-than";
  static SmallerThan = "smaller-than";
  static NotNull = 'not-null';
  static Null = `null`

  static Today = "today";
  static Tomorrow = "tomorrow";
  static Yesterday = "yesterday";
  static ThisWeek = "this-week";
  static NextWeek = "next-week";
  static LastWeek = "last-week";
  static ThisMonth = "this-month";
  static NextMonth = "next-month";
  static LastMonth = "last-month";
  static Last90Days = "last-90-days";
  static Next7Days = "next-7-days";
  static Last7Days = "last-7-days";
  static Next15Days = "next-15-days";
  static Last15Days = "last-15-days";
  static ThisYear = "this-year";
  static LastYear = "last-year";
  static NextYear = "next-year";

  static NumberOfMinutes = "number-minutes";
  static NumberOfHours = "number-hours";
  static NumberOfDays = "number-days";
  static NumberOfWeeks = "number-weeks";
  static NumberOfMonths = "number-months";
  static NumberOfYears = "number-years";
  static StartOfWeek = "start-week";
  static StartOfMonth = "start-month";
  static StartOfYear = "start-year";
  static EndOfWeek = "end-week";
  static EndOfMonth = "end-month";
  static EndOfYear = "end-year";

  static LoggedInUser = "logged-in-user";
  static LoggedInUserTeam = "logged-in-user-team";

  static getFields = (fields) => {
    if (!fields) return [];
    const keys = Object.keys(fields);
    let finalFields = [];
    for (let i = 0; i < keys.length; i++) {
      let field = { ...fields[keys[i]] };
      if (!field.visible && !field.editable) {
        continue;
      }
      if (field.field_type === Const.Address) {
        field.fieldKey = `${keys[i]}${Const.Opt}${Const.Street}`;
        field.field_type = Const.Street;
        field.label_name = `Street`;
        finalFields.push(field);

        field = { ...fields[keys[i]] };
        field.fieldKey = `${keys[i]}${Const.Opt}${Const.City}`;
        field.field_type = Const.City;
        field.label_name = `City`;
        finalFields.push(field);

        field = { ...fields[keys[i]] };
        field.fieldKey = `${keys[i]}${Const.Opt}${Const.State}`;
        field.field_type = Const.State;
        field.label_name = `State`;
        finalFields.push(field);

        field = { ...fields[keys[i]] };
        field.fieldKey = `${keys[i]}${Const.Opt}${Const.Country}`;
        field.field_type = Const.Country;
        field.label_name = `Country`;
        finalFields.push(field);

        field = { ...fields[keys[i]] };
        field.fieldKey = `${keys[i]}${Const.Opt}${Const.Pin}`;
        field.field_type = Const.Pin;
        field.label_name = `Pincode`;
        finalFields.push(field);
      } else {
        field.fieldKey = keys[i];
        finalFields.push(field);
      }
    }
    finalFields.sort((left, right) => left.field_order - right.field_order);
    return finalFields;
  };

  static getFilterFields = (fields, view, ifFilter) => {
    if (!fields) return [];
    const keys = Object.keys(fields);
    let finalFields = [];
    for (let i = 0; i < keys.length; i++) {
      let field = { ...fields[keys[i]] };
      if (ifFilter && !field.filter_visible) {
        continue;
      }

      if (field.field_type === Const.Address) {
        field.fieldKey = `${keys[i]}${Const.Opt}${Const.Street}`;
        field.field_type = Const.Street;
        field.label_name = `Street`;
        finalFields.push(field);

        field = { ...fields[keys[i]] };
        field.fieldKey = `${keys[i]}${Const.Opt}${Const.City}`;
        field.field_type = Const.City;
        field.label_name = `City`;
        finalFields.push(field);

        field = { ...fields[keys[i]] };
        field.fieldKey = `${keys[i]}${Const.Opt}${Const.State}`;
        field.field_type = Const.State;
        field.label_name = `State`;
        finalFields.push(field);

        field = { ...fields[keys[i]] };
        field.fieldKey = `${keys[i]}${Const.Opt}${Const.Country}`;
        field.field_type = Const.Country;
        field.label_name = `Country`;
        finalFields.push(field);

        field = { ...fields[keys[i]] };
        field.fieldKey = `${keys[i]}${Const.Opt}${Const.Pin}`;
        field.field_type = Const.Pin;
        field.label_name = `Pincode`;
        finalFields.push(field);
      } else {
        field.fieldKey = keys[i];
        finalFields.push(field);
      }
    }

    if (view && view.filters) {
      finalFields = finalFields.filter(
        (field) => !view.filters.find((item) => item.field === field.fieldKey)
      );
    }
    return finalFields;
  };

  static getConditions = (type, fieldKey) => {
    const conditions = [];
    if (
      type === Const.Text ||
      type === Const.TextArea ||
      type === Const.MultiValue ||
      type === Const.Street ||
      type === Const.Pin ||
      type === Const.Phone ||
      type === Const.Email
    ) {
      conditions.push({ value: FieldController.Equals, label: "Equals ==" });
      conditions.push({
        value: FieldController.NotEquals,
        label: "Not equals !=",
      });
      conditions.push({ value: FieldController.In, label: "Contains (...)" });
      conditions.push({
        value: FieldController.NotIn,
        label: "Dose not contains (!..)",
      });
      conditions.push({
        value: FieldController.StartWith,
        label: "Starts with %...",
      });
      conditions.push({
        value: FieldController.EndsWith,
        label: "Ends with ...%",
      });
      conditions.push({ value: FieldController.Empty, label: "Empty ---" });
      conditions.push({
        value: FieldController.NotEmpty,
        label: "Not Empty !--",
      });
    } else if (
      type === Const.Number ||
      type === Const.Decimal ||
      type === Const.Duration
    ) {
      conditions.push({ value: FieldController.Equals, label: "Equals ==" });
      conditions.push({ value: FieldController.In, label: "Between <>" });
      conditions.push({
        value: FieldController.NotIn,
        label: "Not between ><",
      });
      conditions.push({
        value: FieldController.StartWith,
        label: "Greater than >",
      });
      conditions.push({
        value: FieldController.EndsWith,
        label: "Less than <",
      });
      conditions.push({ value: FieldController.Empty, label: "Empty ---" });
      conditions.push({
        value: FieldController.NotEmpty,
        label: "Not Empty !--",
      });
    } else if (type === Const.Date || type === Const.DateTime) {
      conditions.push({ value: FieldController.Today, label: "Today" });
      conditions.push({ value: FieldController.Tomorrow, label: "Tomorrow" });
      conditions.push({ value: FieldController.Yesterday, label: "Yesterday" });
      conditions.push({
        value: FieldController.ThisMonth,
        label: "This Month",
      });
      conditions.push({
        value: FieldController.NextMonth,
        label: "Next Month",
      });
      conditions.push({
        value: FieldController.LastMonth,
        label: "Last Month",
      });
      conditions.push({
        value: FieldController.Last90Days,
        label: "Last 90 Days",
      });
      conditions.push({
        value: FieldController.Next7Days,
        label: "Next 7 Days",
      });
      conditions.push({
        value: FieldController.Last7Days,
        label: "Last 7 Days",
      });
      conditions.push({
        value: FieldController.Next15Days,
        label: "Next 15 Days",
      });
      conditions.push({
        value: FieldController.Last15Days,
        label: "Last 15 Days",
      });
      conditions.push({ value: FieldController.ThisYear, label: "This Year" });
      conditions.push({ value: FieldController.LastYear, label: "Last Year" });
      conditions.push({ value: FieldController.NextYear, label: "Next Year" });

      conditions.push({ value: FieldController.In, label: "Between <>" });
      conditions.push({
        value: FieldController.NotIn,
        label: "Not between ><",
      });
      conditions.push({
        value: FieldController.StartWith,
        label: "Greater than >",
      });
      conditions.push({
        value: FieldController.EndsWith,
        label: "Less than <",
      });
      conditions.push({ value: FieldController.Empty, label: "Empty ---" });
      conditions.push({
        value: FieldController.NotEmpty,
        label: "Not Empty !--",
      });
    } else if (
      type === Const.Select ||
      type === Const.MultiSelect ||
      type === Const.City ||
      type === Const.State ||
      type === Const.Country ||
      type.includes(Const.Select) ||
      type.includes(Const.MultiSelect) ||
      type.includes(Const.Status)
    ) {
      if (fieldKey && fieldKey === Const.ResponsiblePerson) {
        conditions.push({
          value: FieldController.LoggedInUser,
          label: "Self without Team",
        });
        conditions.push({
          value: FieldController.LoggedInUserTeam,
          label: "Self with Team",
        });
      }
      conditions.push({ value: FieldController.Equals, label: "Equals ==" });
      conditions.push({
        value: FieldController.NotEquals,
        label: "Not equals !=",
      });
      conditions.push({ value: FieldController.In, label: "Contains (...)" });
      conditions.push({
        value: FieldController.NotIn,
        label: "Dose not contains (!..)",
      });
      conditions.push({ value: FieldController.Empty, label: "Empty ---" });
      conditions.push({
        value: FieldController.NotEmpty,
        label: "Not Empty !--",
      });
    } else if (type === Const.Complete || type === Const.Toggle) {
      conditions.push({ value: FieldController.Empty, label: "All" });
      conditions.push({ value: FieldController.NotIn, label: "Yes" });
      conditions.push({ value: FieldController.In, label: "No" });
    } else if(type === "model" && fieldKey === "model_id"){
      conditions.push({ value: FieldController.NotNull, label: "Has Owner" });
      conditions.push({ value: FieldController.Null, label: "No Owner" });
    }
    return conditions;
  };

  static getDateRangeConditions = () => {
    const conditions = [];
    conditions.push({
      value: FieldController.NumberOfMinutes,
      label: "Number of Minutes",
    });
    conditions.push({
      value: FieldController.NumberOfHours,
      label: "Number of Hours",
    });
    conditions.push({
      value: FieldController.NumberOfDays,
      label: "Number of Days",
    });
    conditions.push({
      value: FieldController.NumberOfWeeks,
      label: "Number of Weeks",
    });
    conditions.push({
      value: FieldController.NumberOfMonths,
      label: "Number of Months",
    });
    conditions.push({
      value: FieldController.NumberOfYears,
      label: "Number of Years",
    });
    conditions.push({
      value: FieldController.StartOfWeek,
      label: "Start of Week",
    });
    conditions.push({
      value: FieldController.StartOfMonth,
      label: "Start of Month",
    });
    conditions.push({
      value: FieldController.StartOfYear,
      label: "Start of Year",
    });
    conditions.push({ value: FieldController.EndOfWeek, label: "End of Week" });
    conditions.push({
      value: FieldController.EndOfMonth,
      label: "End of Month",
    });
    conditions.push({ value: FieldController.EndOfYear, label: "End of Year" });
    return conditions;
  };

  static getConditionText = (filter) => {
    const type = filter.type;
    const condition = filter.condition;
    if (
      type === Const.Text ||
      type === Const.TextArea ||
      type === Const.MultiValue ||
      type === Const.Street ||
      type === Const.Pin ||
      type === Const.Phone ||
      type === Const.Email
    ) {
      if (condition === FieldController.Equals) return "Equals";
      else if (condition === FieldController.NotEquals) return "Not equals";
      else if (condition === FieldController.In) return "Contains";
      else if (condition === FieldController.NotIn) return "Dose not contains";
      else if (condition === FieldController.StartWith) return "Starts with";
      else if (condition === FieldController.EndsWith) return "Ends with";
      else if (condition === FieldController.Empty) return "Empty";
      else if (condition === FieldController.NotEmpty) return "Not Empty";
    } else if (type === Const.Date || type === Const.DateTime) {
      if (condition === FieldController.In) return "Between";
      else if (condition === FieldController.NotIn) return "Not between";
      else if (condition === FieldController.StartWith) return "Greater than";
      else if (condition === FieldController.EndsWith) return "Less than";
      else if (condition === FieldController.Empty) return "Empty";
      else if (condition === FieldController.NotEmpty) return "Not Empty";
    } else if (
      type === Const.Select ||
      type === Const.MultiSelect ||
      type === Const.City ||
      type === Const.State ||
      type === Const.Country ||
      type.includes(Const.Select) ||
      type.includes(Const.MultiSelect)
    ) {
      if (condition === FieldController.Equals) return "Equals";
      else if (condition === FieldController.NotEquals) return "Not equals";
      else if (condition === FieldController.In) return "Contains";
      else if (condition === FieldController.NotIn) return "Dose not contains";
      else if (condition === FieldController.Empty) return "Empty";
      else if (condition === FieldController.NotEmpty) return "Not Empty";
    }
    return "";
  };

  static getConditionValue = (filter, field) => {
    let value = filter.value;
    const type = filter.type;
    if (type === Const.Date || type === Const.DateTime) {
      const values = value.split(Const.Opt);
      if (value !== "" && value.indexOf(Const.Opt) === 0) {
        return Util.dateToDisplayDate(
          Util.serverStringDateTimeToDate(values[1])
        );
      } else if (
        value !== "" &&
        value.indexOf(Const.Opt) === value.length - 1
      ) {
        return Util.dateToDisplayDate(
          Util.serverStringDateTimeToDate(values[0])
        );
      } else if (value !== "") {
        const from = Util.dateToDisplayDate(
          Util.serverStringDateTimeToDate(values[0])
        );
        const to = Util.dateToDisplayDate(
          Util.serverStringDateTimeToDate(values[1])
        );
        return from + " to " + to;
      }
    } else if (
      type.includes(Const.Select) ||
      type === Const.City ||
      type === Const.State ||
      type === Const.Country
    ) {
      const values = value.substring(1, value.length - 1).split(Const.Opt);
      value = "";
      const options = this.getOptions(field);
      for (let i = 0; i < values.length; i++) {
        for (let j = 0; j < options.length; j++) {
          if (parseInt(options[j].value) === parseInt(values[i])) {
            value =
              value !== "" ? value + ", " + options[j].label : options[j].label;
            break;
          }
        }
      }
      return value;
    }
    return value;
  };

  static showTextFilter = (type, condition) => {
    if (
      type === Const.Text ||
      type === Const.TextArea ||
      type === Const.MultiValue ||
      type === Const.Street ||
      type === Const.Pin ||
      type === Const.Phone ||
      type === Const.Email
    ) {
      return (
        condition !== FieldController.Empty &&
        condition !== FieldController.NotEmpty &&
        condition !== ""
      );
    }
    return false;
  };

  static showDateFrom = (type, condition) => {
    if (
      type === Const.Date ||
      type === Const.DateTime ||
      type === Const.Number
    ) {
      return (
        condition !== FieldController.Empty &&
        condition !== FieldController.NotEmpty &&
        condition !== "" &&
        condition !== FieldController.EndsWith
      );
    }
    return false;
  };

  static showDateTo = (type, condition) => {
    if (
      type === Const.Date ||
      type === Const.DateTime ||
      type === Const.Number
    ) {
      return (
        condition !== FieldController.Empty &&
        condition !== FieldController.NotEmpty &&
        condition !== "" &&
        condition !== FieldController.StartWith
      );
    }
    return false;
  };

  static showSelect = (type, condition) => {
    if (
      type === Const.Select ||
      type === Const.MultiSelect ||
      type.includes(Const.Select) ||
      type.includes(Const.MultiSelect)
    ) {
      return (
        condition !== FieldController.Empty &&
        condition !== FieldController.Empty &&
        condition !== ""
      );
    }
    return false;
  };

  static showComplete = (type, condition) => {
    if (type === Const.Toggle || type === Const.Complete) {
      return (
        condition !== Filter.Empty &&
        condition !== Filter.Empty &&
        condition !== ""
      );
    }
    return false;
  };

  static showCity = (type, condition) => {
    return (
      condition !== "" &&
      type === Const.City &&
      condition !== FieldController.Empty &&
      condition !== FieldController.Empty
    );
  };

  static showState = (type, condition) => {
    return (
      type === Const.State &&
      condition !== FieldController.Empty &&
      condition !== FieldController.Empty
    );
  };

  static showCountry = (type, condition) => {
    return (
      type === Const.Country &&
      condition !== FieldController.Empty &&
      condition !== FieldController.Empty
    );
  };

  static showMultiSelectConditional = (type, condition) => {
    return (
      type.includes(Const.MultiSelect) &&
      condition !== FieldController.Empty &&
      condition !== FieldController.Empty
    );
  };

  static showSelectConditional = (type, condition) => {
    return (
      !type.includes(Const.MultiSelect) &&
      type.includes(Const.Select) &&
      condition !== FieldController.Empty &&
      condition !== FieldController.Empty
    );
  };

  static getOptions = (field, modelField, isActive) => {
    if (!field && modelField && modelField.includes(Const.Opt)) {
      field = { field_type: modelField.split(Const.Opt)[1] };
    }

    let options = [];
    const type = field.field_type;

    if (!field) {
      return [];
    }

    // View Update type made static
    if (field.model_no === 60 && field.field_key === "type") {
      return [
        { value: 0, label: "Main View", status: 4 },
        { value: 1, label: "Public", status: 4 },
        { value: 2, label: "Role", status: 4 },
        { value: 3, label: "User", status: 4 },
      ];
    }

    // Mass Campaign status
    if (
      (field.model_no === 45 ||
        field.model_no === 46 ||
        field.model_no === 66) &&
      field.field_key === "operation_status"
    ) {
      return [
        { value: 1, label: "Active", status: 4 },
        { value: 2, label: "Failed", status: 4 },
        { value: 3, label: "Successful", status: 4 },
        { value: 4, label: "In Process", status: 4 },
      ];
    }

    if (type.includes(Const.Opt + "area")) {
      options = reactLocalStorage.getObject(Const.Areas);
    } else if (type.includes(Const.Opt + "tower") && !field.options) {
      options = reactLocalStorage.getObject(Const.Towers);
    } else if (type.includes(Const.Opt + "room") && !field.options) {
      options = reactLocalStorage.getObject(Const.Rooms);
    } else if (type.includes(Const.Opt + "product")) {
      options = reactLocalStorage.getObject(Const.Products);
    } else if (type.includes(Const.Opt) && type.includes(Const.Select)) {
      const splitField = type.split(Const.Opt);
      const modelName = splitField[1];
      const models = reactLocalStorage.getObject(Const.Model);
      if (models[modelName]) {
        if (splitField.length === 2) {
          options = models[modelName].options;
        } else if (splitField.length === 3) {
          options = models[modelName].fields[splitField[2]].options;
        }
      }
      if (!options && field.options) options = field.options;
    } else if (type === Const.City)
      options = reactLocalStorage.getObject(Const.Cities);
    else if (type === Const.State)
      options = reactLocalStorage.getObject(Const.States);
    else if (type === Const.Country)
      options = reactLocalStorage.getObject(Const.Countries);
    else if (field.field_type === Const.Status) {
      options = [
        {
          label: Const.TextActive,
          value: Const.Active,
          status: Const.AlwaysActive,
        },
        {
          label: Const.TextTrash,
          value: Const.Trash,
          status: Const.AlwaysActive,
        },
        {
          label: Const.TextDeactive,
          value: Const.Deactive,
          status: Const.AlwaysActive,
        },
        {
          label: Const.TextAlwaysActive,
          value: Const.AlwaysActive,
          status: Const.AlwaysActive,
        },
      ];
    } else if (type === Const.Date || type === Const.DateTime)
      options = [{ label: "Now", value: "now", status: 1 }];
    else if (field.options) options = field.options;
    else if (type === Const.Complete)
      options = [
        { label: "Completed", value: 1, status: 1 },
        { label: "Pending", value: 0, status: 1 },
      ];

    options =
      options && options.sort
        ? options.sort((left, right) =>
            left.order && right.order ? left.order - right.order : 0
          )
        : [];

    if (isActive) {
      options = options.filter(
        (option) =>
          option.status &&
          (option.status === 1 || option.status === 4 || option.status === 5)
      );
    }

    return options;
  };

  static isMulti = (condition) =>
    condition !== FieldController.Equals &&
    condition !== FieldController.NotEquals;
}
export default FieldController;
